import { gql } from "graphql-tag";
import { useMutation } from "@bb-vendure/admin-ui/react";
import { CUSTOMS_CLEARANCE_BODY } from "./Get-Customs-Clearance";

const ADD_CUSTOMS_CLEARANCE_FILES = gql`
  mutation AddCustomsClearanceFiles($id: ID!, $assetIds: [String!]!) {
    addCustomsClearanceFiles(id: $id, assetIds: $assetIds) {
    ${CUSTOMS_CLEARANCE_BODY}
    }
  }
`;

export default function useAddCustomClearanceFiles<T>() {
  return useMutation<T>(ADD_CUSTOMS_CLEARANCE_FILES);
}
